<script setup lang="ts">
import { useToast } from './index.hook'
import ToastItem from './ToastItem.vue'

defineOptions({
  name: 'ToastProvider',
})

const { toasts, dismiss } = useToast()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="toasts.length"
      class="toast-provider"
    >
      <TransitionGroup
        name="toast"
        tag="div"
        class="toast-provider__list"
      >
        <ToastItem
          v-for="toast in toasts"
          :key="toast.id"
          :toast="toast"
          @dismiss="dismiss"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped lang="scss" src="./ToastProvider.scss" />
